import ChairSearch from '../../src/legacy/ChairSearch.tsx';
export default ChairSearch;
